import { render, staticRenderFns } from "./QuickLook.vue?vue&type=template&id=016f5859&scoped=true&"
import script from "./QuickLook.vue?vue&type=script&lang=js&"
export * from "./QuickLook.vue?vue&type=script&lang=js&"
import style0 from "./QuickLook.vue?vue&type=style&index=0&id=016f5859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f5859",
  null
  
)

export default component.exports